export default __webpack_public_path__ + "static/media/home-travel-agency-hotel-img01.862c658c.jpg";